<template>
  <b-card
      title="مدیریت لینک ها"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                  class="mb-1 ml-1"
                  variant="primary"
                  @click="addUrlMap()"
              >
                جدید
              </b-button>
              <b-button
                  variant="success"
                  class="mb-1 mr-auto ml-1"
                  @click="clearCache"
              >
                بروزرسانی
              </b-button>
              <b-col md="2">
                <b-form-group
                    label="عنوان"
                    label-for="Title"
                >
                  <b-form-input
                      v-model="filterOptions.Title"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="وضعیت"
                    label-for="IsActive"
                >
                  <v-select
                      v-model="filterOptions.IsActive"
                      :options="enums('IsActive')"
                      dir="rtl"
                      label="text"
                      :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>

              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  class="mb-1 mr-1"
                  variant="warning"
                  @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
                @click="updateUrlMap(data.item)"
                class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(IsActive)="data">
            <b-badge
                :variant="data.value ? 'success' : 'warning'"
            >
              {{ data.value ? 'فعال' : 'غیرفعال' }}
            </b-badge>
          </template>

          <template #cell(StatusCode)="data">
            <b-badge
                :variant="'light-'+enums('UrlMapType', 'value', data.value, 'badge')"
            >
              {{ enums('UrlMapType', 'value', data.value, 'key') }}
            </b-badge>
          </template>


          <template #cell(actions)="data">

            <div
                class="text-nowrap"
            >
              <b-link @click="updateUrlMap(data.item)">
                <feather-icon
                    :id="`invoice-row-${data.item.Id}-send-icon`"
                    icon="EditIcon"
                    size="16"
                />
              </b-link>

              <feather-icon

                  icon="TrashIcon"
                  size="16"
                  class="ml-1 cursor-pointer"
                  @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
            :page="filterOptions.Page"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
        />

      </b-col>

    </b-row>

    <b-modal
        v-model="showUrlMapModal"
        v-if="showUrlMapModal"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        title="جزئیات لینک"
        :no-close-on-backdrop="true"
        size="sm"
        @ok="save"
    >
<b-row>
      <b-col md="6">
        <b-form-group
            label="نوع"
            label-for="StatusCode"
        >
          <v-select
              v-model="row.StatusCode"
              dir="rtl"
              :reduce="x => x.value"
              label="key"
              :clearable="false"
              :options="enums('UrlMapType')"
          />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group
            label="وضعیت"
            label-for="IsActive"
        >
          <v-select
              v-model="row.IsActive"
              :options="enums('IsActive')"
              dir="rtl"
              label="text"
              :clearable="false"
              :reduce="x => x.value"
          />
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-form-group
            label="منبع"
            label-for="Source"
        >
          <b-form-input
              v-model="row.Source"
              id="Source"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-form-group
            label="مقصد"
            label-for="Destination"
        >
          <b-form-input
              v-model="row.Destination"
              id="Destination"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>
</b-row>
    </b-modal>
  </b-card>
</template>

<script>
import ZState from "@/tools/state.vue";

export default {
  name: 'UrlMap',
  components: { ZState},
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Page: 1
      },
      showUrlMapModal: false,
      row:{},
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'StatusCode',
          label: 'نوع',
        },
        {
          key: 'Source',
          label: 'منبع',
        },
        {
          key: 'Destination',
          label: 'مقصد',
        },
        {
          key: 'IsActive',
          label: 'وضعیت',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
          this.$api.urlmap.getlist, this.filterOptions,
      )
          .then(res => {
            this.totalRows = res.totalRow
            this.items = res.data
          })
          .finally(() => {
            this.loading = false
          })
    },
    clearCache() {
      this.loading = true

      this.$http.post(
          this.$api.urlmap.clearcache, null,
      )
          .then(res => {
            this.update()
          })
    },
    save() {
      let url = this.$api.urlmap.add
      if (this.row.Id) {
        url = this.$api.urlmap.update
      }

      this.$http.post(
          url, this.row,
      )
          .then(() => {
            this.update()
          })
          .catch(() => {
            this.showUrlMapModal = true
          })
    },
    addUrlMap(){
      this.row = { Source: null, Destination : null,StatusCode: 0,IsActive:true}
      this.showUrlMapModal = true
    },
    updateUrlMap(row){
      this.row =   JSON.parse(JSON.stringify(row))
      this.showUrlMapModal = true
    },
    remove(id) {
      this.removeRow(this.$api.urlmap.remove, 'Id', id)
    },
  },
}
</script>

<style scoped>

</style>